<servicerapport-accordion-panel [formGroup]="formGroup" [title]="formGroup.value.navn" (opret)="onOpret()">
  @if (komponenter.length) {
    <mat-accordion>
      @for (komponent of komponenter; track komponent; let i = $index) {
        <mat-expansion-panel #panel>
          <mat-expansion-panel-header>
            <accordion-status-indicator [formGroup]="komponent"></accordion-status-indicator>
            <mat-panel-title>{{ getKomponentType(komponent.value).navn }}</mat-panel-title>
            <mat-panel-description>{{ komponent.value.fabrikatNavn }}</mat-panel-description>
            @if (panel.expanded) {
              <div class="buttons">
                <button mat-button type="button" color="warn" (click)="onSlet($event, komponent)">SLET</button>
              </div>
            }
          </mat-expansion-panel-header>
          <komponent [formGroup]="komponent"></komponent>
        </mat-expansion-panel>
      }
    </mat-accordion>
  }

  @if (!komponenter.length) {
    <div class="empty">
      Der er endnu ikke registreret komponenter i denne gruppe.
    </div>
  }
</servicerapport-accordion-panel>
